export default __webpack_public_path__ + "static/media/330_store05-jp-web.5974e93f.png";